import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { BookOpenIcon, CalendarIcon, MonitorIcon, CheckCircleIcon } from 'lucide-react';
export function BenefitsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const benefits = [{
    icon: BookOpenIcon,
    title: 'Ebook Maestro: Código Longevidad',
    description: 'El manual completo con la ciencia de la sarcopenia, nutrición para fuerza, y el protocolo de Tensión Estructural explicado paso a paso.',
    features: ['Fundamentos científicos de la longevidad muscular', 'Anatomía funcional para +35', 'Protocolos de recuperación optimizados', 'Guía de suplementación basada en evidencia']
  }, {
    icon: CalendarIcon,
    title: 'Plan de Entrenamiento "Blindaje"',
    description: '12 semanas de programación detallada con progresión estructurada. Cada sesión, cada serie, cada descanso está calculado.',
    features: ['36 sesiones completas (3x/semana)', 'Videos demostrativos de cada ejercicio', 'Progresión de carga automática', 'Variantes según equipamiento disponible']
  }, {
    icon: MonitorIcon,
    title: 'Guía de Postura para Oficinistas',
    description: 'Protocolo específico para revertir el daño de años frente a la pantalla. Ejercicios correctivos y preventivos.',
    features: ['Evaluación postural paso a paso', 'Rutina de movilidad de 10 minutos', 'Ejercicios de escritorio', 'Setup ergonómico optimizado']
  }];
  return <section ref={ref} className="w-full bg-bg-secondary py-20 px-4 sm:px-6 lg:px-8" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-3">
          <h2 className="font-heading text-5xl sm:text-6xl lg:text-7xl text-text-primary mb-6" data-id="element-4">
            Qué incluye el{' '}
            <span className="text-accent-bronze" data-id="element-5">protocolo completo</span>
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto font-body" data-id="element-6">
            Todo lo que necesitás para blindar tu estructura y recuperar la
            autonomía física. Sin relleno, sin teoría innecesaria.
          </p>
        </motion.div>

        <div className="space-y-8" data-id="element-7">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={benefit.title} initial={{
            opacity: 0,
            x: -30
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="bg-bg-primary border border-accent-bronze/20 rounded-sm overflow-hidden hover:border-accent-bronze/40 transition-colors duration-300" data-id="element-8">
                <div className="p-8 sm:p-10" data-id="element-9">
                  <div className="flex items-start gap-6 mb-6" data-id="element-10">
                    <div className="flex-shrink-0 w-16 h-16 bg-accent-bronze/10 rounded-sm flex items-center justify-center" data-id="element-11">
                      <Icon className="w-8 h-8 text-accent-bronze" data-id="element-12" />
                    </div>
                    <div className="flex-1" data-id="element-13">
                      <h3 className="font-heading text-3xl sm:text-4xl text-text-primary mb-3" data-id="element-14">
                        {benefit.title}
                      </h3>
                      <p className="text-lg text-text-secondary font-body leading-relaxed" data-id="element-15">
                        {benefit.description}
                      </p>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 ml-0 sm:ml-22" data-id="element-16">
                    {benefit.features.map((feature, featureIndex) => <motion.div key={featureIndex} initial={{
                  opacity: 0,
                  x: -20
                }} animate={isInView ? {
                  opacity: 1,
                  x: 0
                } : {}} transition={{
                  duration: 0.4,
                  delay: index * 0.2 + featureIndex * 0.1
                }} className="flex items-start gap-3" data-id="element-17">
                        <CheckCircleIcon className="w-5 h-5 text-accent-bronze flex-shrink-0 mt-0.5" data-id="element-18" />
                        <span className="text-text-secondary font-body text-sm leading-relaxed" data-id="element-19">
                          {feature}
                        </span>
                      </motion.div>)}
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-12 bg-gradient-to-r from-accent-bronze/10 to-bg-tertiary border border-accent-bronze/30 rounded-sm p-8 text-center" data-id="element-20">
          <p className="text-xl text-text-primary font-body mb-2" data-id="element-21">
            <span className="font-heading text-3xl text-accent-bronze" data-id="element-22">
              Valor total:
            </span>{' '}
            $28,99 USD
          </p>
          <p className="text-lg text-text-secondary font-body" data-id="element-23">
            Tu inversión hoy:{' '}
            <span className="text-accent-gold font-bold" data-id="element-24">$6,39 USD</span>
          </p>
        </motion.div>
      </div>
    </section>;
}